/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef } from 'react';

import styled, { css } from 'styled-components';

import { Icon, theme } from 'fpay-ui';

const SearchButton = styled(Icon)(
  () => css`
    width: 24px;
    height: 24px;
    margin-right: 8px;
  `
);

const CancelButton = styled(Icon)(
  ({ inputText }) => css`
    width: 24px;
    height: 24px;
    cursor: pointer;
    ${inputText === false
      ? css`
          display: none;
        `
      : css`
          display: flex;
        `}
  `
);

const LayoutCancelButton = styled.div`
  display: flex;
`;

const Container = styled.div(
  ({ theme }) => css`
    position: relative;
    display: flex;
    width: 220px;
    height: 100%;
    margin-right: 16px;
    flex-direction: column;
    ${theme.breakpoint('md')} {
      margin-right: 0px;
      width: 100%;
    }
    ${theme.breakpoint('ll')} {
      margin-right: 16px;
      width: 328px;
      /* width: 100%; */
    }
  `
);

const ContainerInput = styled.div(
  ({ theme }) => css`
    height: 40px;
    display: flex;
    border-radius: 4px;
    border: solid 1px ${theme.colors.gray500};
    border-color: ${(props) =>
      props.inputText ? `${theme.colors.gbrand500}` : `${theme.colors.gray500}`};
    align-items: center;
    padding: 0 16px;
    :focus,
    :hover:not(:focus):not(:disabled) {
      border: solid 1px ${theme.colors.gbrand500};
    }
  `
);

const ContainerDisplayOptions = styled.div`
  width: 100%;
  background-color: #ffffff;
  z-index: 1;
  box-sizing: border-box;
  position: absolute;
  top: 100%;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  &:first-child {
    margin-top: 8px;
  }
  &:last-child {
    margin-bottom: 8px;
  }
  padding: 8px 0;
`;
export const ContainerDisplayText = styled.div(
  ({ theme }) => css`
    display: flex;
    padding: 8px 16px;
    ${theme.textTypes['Caption-w400']}
    text-overflow: ellipsis;
    letter-spacing: 0.5px;
    text-align: left;
    font-weight: ${(props) => props.fontWeightTextNormal || '700'};
    color: ${(props) => props.fontColorTextNormal || `${theme.colors.gray700}`};
    align-items: center;
    text-align: left;
    align-items: center;
  `
);

export const Match = styled(ContainerDisplayText)`
  cursor: pointer;
  &:hover {
    background-color: ${theme.colors.gray200};
  }
`;

export const NoMatch = styled(ContainerDisplayText)`
  font-weight: ${(props) => props.fontWeightTextNoMatch || '700'};
  color: ${(props) => props.fontColorTextNoMatch || `${theme.colors.gray700}`};
  cursor: default;
`;

const Input = styled.input(
  ({ theme }) => css`
    ${theme.textTypes['Body-2-w400']}
    line-height: 1.71;
    text-align: left;
    color: ${theme.colors.gray800};
    border: 0;
    outline: none;
    width: 100%;
    background-color: transparent;
    text-overflow: ellipsis;
    ::placeholder {
      ${theme.textTypes['Body-2-w400']}
      line-height: 1.71;
      text-align: left;
      color: ${(props) => props.fontColorPlaceHolder || `${theme.colors.gray800}`};
      border: none;
    }
  `
);
const MarkText = styled.b(
  ({ theme }) => css`
    ${theme.textTypes['Caption-w400']}
    align-items: center;
    font-weight: ${(props) => props.fontWeightTextMark || 'normal'};
    color: ${(props) => props.fontColorTextMark || `${theme.colors.gray700}`};
  `
);

const StyleP = styled.p`
  margin: 0;
`;

const InputSearch = ({
  options,
  placeHolder,
  fontWeightTextNormal,
  fontColorTextNormal,
  fontWeightTextMark,
  fontColorTextMark,
  fontWeightTextNoMatch,
  fontColorTextNoMatch,
  noMatchText,
  handleCancel,
  idMovement,
  placeHolderColor,
  handleCleanFilterSearch,
  limitRenderOptions = 5,
  matchOption: matchOptionProps,
  value,
}) => {
  const wrapperRef = useRef(null);
  const [inputSearchState, setInputSearchState] = useState({
    searchtext: value || '',
    suggest: [],
    resfound: true,
    inputText: false,
    display: false,
  });

  useEffect(() => {
    setInputSearchState({ ...inputSearchState, searchtext: value });
    if (!value || value === '') setInputSearchState({ ...inputSearchState, inputText: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const matchOption = (option, labelSearch) => {
    if (matchOptionProps) {
      return matchOptionProps(option, labelSearch);
    }
    return option.toLowerCase().includes(labelSearch.toLowerCase());
  };

  const updateDisplay = (labelSearch) => {
    if (labelSearch?.length > 2 && !!options) {
      const suggestion = options
        .filter((e) => matchOption(e, labelSearch))
        .slice(0, limitRenderOptions);
      setInputSearchState({
        resfound: suggestion.length !== 0,
        suggest: suggestion,
        display: true,
        searchtext: labelSearch,
      });
    } else {
      setInputSearchState({
        ...inputSearchState,
        suggest: [],
        display: false,
        searchtext: labelSearch,
      });
    }
  };

  const handleClose = () => {
    setInputSearchState({
      searchtext: '',
      suggest: [],
      inputText: false,
      display: false,
    });
    handleCleanFilterSearch();
  };

  const handleChange = (e) => {
    const searchval = e.target.value;

    const isEmptySearch = searchval === '';
    if (isEmptySearch) {
      handleClose();
    } else {
      setInputSearchState({ ...inputSearchState, searchtext: searchval, inputText: true });
      updateDisplay(searchval);
    }
  };

  const handleClickOutside = (event) => {
    const { current: wrap } = wrapperRef;
    if (wrap && !wrap.contains(event.target)) {
      setInputSearchState({ ...inputSearchState, display: false });
    }
  };

  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const suggestedText = (value) => {
    // eslint-disable-next-line no-unused-expressions
    idMovement && idMovement(value);
    setInputSearchState({ ...inputSearchState, searchtext: value, suggest: [], display: false });
  };

  const getSuggestions = () => {
    if (
      inputSearchState?.suggest?.length === 0 &&
      inputSearchState?.searchtext !== '' &&
      !inputSearchState?.resfound
    ) {
      return (
        noMatchText && (
          <NoMatch
            fontWeightTextNoMatch={fontWeightTextNoMatch}
            fontColorTextNoMatch={fontColorTextNoMatch}
          >
            {noMatchText}
          </NoMatch>
        )
      );
    }

    const Highlight = ({ search = '', children = '' }) => {
      const text = String(children);
      const query = String(search);

      if (!query) return children;

      const lowerText = text.toLowerCase();
      const lowerQuery = query.toLowerCase();
      const qlen = lowerQuery.length;

      const fragments = [];
      let idx = 0;
      let pos = lowerText.indexOf(lowerQuery, idx);

      while (pos !== -1) {
        if (pos > idx) {
          fragments.push(text.slice(idx, pos));
        }
        const match = text.slice(pos, pos + qlen);
        fragments.push(
          <MarkText
            fontWeightTextMark={fontWeightTextMark}
            fontColorTextMark={fontColorTextMark}
            key={`${pos}-${qlen}`}
          >
            {match}
          </MarkText>
        );
        idx = pos + qlen;
        pos = lowerText.indexOf(lowerQuery, idx);
      }

      if (idx < text.length) {
        fragments.push(text.slice(idx));
      }

      return <StyleP>{fragments}</StyleP>;
    };

    return (
      <>
        {inputSearchState?.suggest?.map((item, index) => (
          <Match
            key={index}
            fontWeightTextNormal={fontWeightTextNormal}
            fontColorTextNormal={fontColorTextNormal}
            onClick={() => suggestedText(item)}
          >
            <Highlight search={inputSearchState.searchtext}>{item}</Highlight>
          </Match>
        ))}
      </>
    );
  };
  return (
    <>
      <Container ref={wrapperRef}>
        <ContainerInput inputText={inputSearchState.inputText}>
          <SearchButton icon="ic_search_24" />
          <Input
            autoComplete="off"
            type="text"
            placeholder={placeHolder}
            fontColorPlaceHolder={placeHolderColor}
            className="search"
            value={inputSearchState.searchtext}
            onChange={handleChange}
            onClick={() => updateDisplay(inputSearchState.searchtext)}
            onKeyPress={(e) => e.key === 'Enter' && suggestedText(e.target.value)}
            id="input"
            data-testid="setdisplay"
          />
          <LayoutCancelButton
            onClick={handleClose}
            onChange={handleCancel}
            data-testid="close-button"
          >
            <CancelButton inputText={inputSearchState.inputText} icon="ic_cancel_24" />
          </LayoutCancelButton>
        </ContainerInput>
        {inputSearchState.display && (
          <ContainerDisplayOptions>{getSuggestions()}</ContainerDisplayOptions>
        )}
      </Container>
    </>
  );
};

export default InputSearch;
